<template>
  <div class="mb-8">
    <div class="col-photo-file">
      <img
        :src="src"
        alt="Licencia frontal"
        class="background-license"
        v-if="src"
      />
      <img
        :src="require(`../../assets/background/${this.background}.svg`)"
        alt="Licencia frontal"
        class="background-license"
        :class="{ 'background-license--error': error }"
        v-else
      />
      <div class="button-file file-photo">
        <div class="label">
          <a-icon :name="icon" />
          <span>
            {{ label }}
          </span>
        </div>
        <input
          type="file"
          name="upload"
          class="input-file"
          accept="image/jpeg"
          capture="camera"
          :placeholder="label"
          @change="handleFileChange"
        />
      </div>
    </div>
    <div
      class="form-text-validation form-text-validation--error text-center"
      v-if="error"
    >
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import AIcon from '@/components/ui/AIcon';

export default {
  props: {
    background: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: String,
    value: [Array, Object, File, String],
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    AIcon,
  },
  data() {
    return {
      src: null,
    };
  },
  methods: {
    handleFileChange(e) {
      const file = e.target.files[0];
      this.src = URL.createObjectURL(file);
      this.$emit('input', file);
    },
  },
};
</script>

<style></style>
